export const SEARCH_TYPES = ['vehicle', 'market', 'dealer', 'explore']

export const DEFAULT_SEARCH_TYPE = 'vehicle'
